<app-topnav [llttfPage]="true" [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="h-30"></div>
    <div class="facility-heading">View Cohort Invitation</div>
    <form>
      <div class="designatedFacilityForm">
        <div class="review-form-fileds-status">
          <span class="heading">Invitation Details</span>
          <span class="reviewstatus-{{llttfInvitation.status.toLowerCase()}}">{{llttfInvitation.statusDescription.toUpperCase()}}</span>
        </div>
        <div class="mb-10"></div>
        <div class="review-form-fileds">
          <span class="label" >Cohort Name</span>
          <span class="answers">{{llttfInvitation.cohortName}}</span>
        </div>


        <div class="review-form-fileds">
          <span class="label">Organization</span>
          <span class="answers">{{llttfInvitation.organization}}</span>

        </div>


        <div class="review-form-fileds">
          <span class="label">Facilitator</span>
          <span class="answers">{{llttfInvitation.facilitator}}</span>

        </div>


        <div class="review-form-fileds">
          <span class="label">Participant Limit</span>
          <span class="answers">{{llttfInvitation.participantLimit}}</span>

        </div>

        <div class="review-form-fileds">
          <span class="label">Current Enrollment</span>
          <span class="answers">{{llttfInvitation.currentEnrollment}}</span>

        </div>

        <div class="review-form-fileds">
          <span class="label">Program Start Date</span>
          <span class="answers">{{llttfInvitation.programStartDate}}</span>

        </div>


        <div class="review-form-fileds">
          <span class="label">Invite Expiry Date</span>
          <span class="answers">{{llttfInvitation.inviteExpiryDate}}</span>

        </div>


        <div class="review-form-fileds">
          <span class="label">Invite Link</span>
          <span class="answers" [hidden]="!isUrl()"><a [href]="llttfInvitation.inviteLink">{{llttfInvitation.inviteLink}}</a></span>
          <span class="answers" [hidden]="isUrl()">{{llttfInvitation.inviteLink}}</span>
          &nbsp;<span [hidden]="!isUrl()"><img src="assets/copy.svg" (click)="copyToClipboard(llttfInvitation.inviteLink)"></span>
        </div>
        <div class="h-30"></div>
        <div class="enrollmentDiv">
          <span class="heading">Enrollment Details</span>
          <div class="mb-10"></div>
          <span [hidden]="llttfInvitation.enrollments.length>0">No participants are currently enrolled in this cohort.</span>
          <table [hidden]="llttfInvitation.enrollments.length==0">
            <tr>
              <th><strong>Email Address</strong></th>
              <th><strong>Date Accessed</strong></th>
            </tr>
            @for (item of llttfInvitation.enrollments; track item) {
              <tr>
                <td>{{ item.emailAddress }}</td>
                <td>{{ item.dateAccessed }}</td>
              </tr>
            }
          </table>
        </div>

        <div class="h-30"></div>
        <div class="form-buttons">
          <button class="submit-form-button" (click)="navigate()" [hidden]="!showEditButton">Edit</button>
          <button class="delete-button" (click)="deleteInvite()" [hidden]="!llttfInvitation.isDeleteEnabled && !showEditButton">Delete Cohort</button>
        </div>

      </div>
    </form>
    <app-audit-logs [auditLogs]="auditLogs"></app-audit-logs>
  </div>

</div>

<app-footer></app-footer>

@if (modalOpen | async) {
  <app-modal [title]="modalTitle" [content]="modalContent" [okButtonValue]="modalOkButtonValue"
  [cancelButtonValue]="modalCancelButtonValue" [okButtonText]="modalOkButtonText" [cancelButtonText]="modalCancelButtonText"></app-modal>
}
